module.exports = __webpack_public_path__ + "media/public/images/icon-search-72b48c948bf629dfd36eacfff072c562.svg";